/**
 * classifyEnv.js : niveau de la moyenne de température ou d'humidité d'une
 * session (badge des cartes de la page de session).
 *
 * Reprend exactement la règle du bloc « Alertes seuils équins » retiré en
 * 10.5.313 (D239), qui était le seul à dire ce niveau en mots : dans la plage
 * normale de pmThresholds.json → 'bon', hors plage → 'a_surveiller' avec le
 * sens du dépassement, valeur absente → 'non_mesure' (jamais classée « bon »,
 * D-NULL). Deux paliers seulement : la température et l'humidité n'ont pas
 * de palier « élevé » sur cette page.
 */
import { TEMP_THRESHOLDS, HUMIDITY_THRESHOLDS } from './pmThresholds';

const RANGES = {
  temperature: { min: TEMP_THRESHOLDS.normalMin, max: TEMP_THRESHOLDS.normalMax, below: 'tooCold', above: 'tooHot' },
  humidity:    { min: HUMIDITY_THRESHOLDS.normalMin, max: HUMIDITY_THRESHOLDS.normalMax, below: 'tooDry', above: 'tooHumid' },
};

/**
 * @param {number|null} value  Moyenne mesurée (°C ou %).
 * @param {'temperature'|'humidity'} kind
 * @returns {{ level: 'bon'|'a_surveiller'|'non_mesure',
 *             note: null|'tooCold'|'tooHot'|'tooDry'|'tooHumid' }}
 *   `note` : clé `alerts.note.*` du sens du dépassement.
 */
export function classifyEnv(value, kind) {
  const range = RANGES[kind];
  if (!range) {
    throw new Error(`classifyEnv: grandeur inconnue « ${kind} » (attendu 'temperature' | 'humidity')`);
  }
  if (typeof value !== 'number' || !Number.isFinite(value)) return { level: 'non_mesure', note: null };
  if (value < range.min) return { level: 'a_surveiller', note: range.below };
  if (value > range.max) return { level: 'a_surveiller', note: range.above };
  return { level: 'bon', note: null };
}
